
import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../../redux/modules/actions';
import DemoScheduledLeads          from './DemoScheduledLeads';

const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterPage: actions.enterPage,
        leavePage: actions.leavePage,
        fetchScoreCardDataIfNeeded:   actions.fetchScoreCardDataIfNeeded,
        fetchStatsTableDataIfNeeded:  actions.fetchStatsTableDataIfNeeded,
        fetchStatsGraphDataIfNeeded:  actions.fetchStatsGraphDataIfNeeded,
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DemoScheduledLeads);



// WEBPACK FOOTER //
// ./src/app/views/partner/demoScheduledLeads/index.js